import { Link as LinkComponent } from "../../components/atoms/Link";
import styled from "styled-components";
import colours from "../../lib/colours";
import appConfig from "../../lib/appConfig";
import { nvEmailAddress } from "../../lib/constants";

const StyledFooter = styled.footer`
  display: flex;
  background-color: ${colours.th1};
  color: ${colours.white};
  margin-top: auto;
`;

const FluidContainer = styled.div`
  max-width: ${appConfig.homePageContentWidth};
  padding-inline: 1rem;
  padding-block: 3.75rem;
  margin: auto;
`;

const FooterOuterContainer = styled(FluidContainer)`
  padding-block: 2rem;
`;

const FooterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const FooterLinkComponent = styled(LinkComponent)`
  color: ${colours.white};
  text-decoration: none;
  margin-right: 28px;
  margin-block: 8px;

  &:last-child {
    margin-right: 0;
  }

  &: hover {
    text-decoration: underline;
  }
`;

function Footer() {
  return (
    <StyledFooter>
      <FooterOuterContainer>
        <FooterContainer>
          <FooterLinkComponent
            href="Terms-of-use.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of use
          </FooterLinkComponent>
          <FooterLinkComponent href="http://www.delwp.vic.gov.au/accessibility">
            Accessibility
          </FooterLinkComponent>
          <FooterLinkComponent href="http://www.delwp.vic.gov.au/privacy">
            Privacy
          </FooterLinkComponent>
          <FooterLinkComponent href="http://www.delwp.vic.gov.au/copyright">
            Copyright
          </FooterLinkComponent>
          <FooterLinkComponent
            href={`mailto:${nvEmailAddress}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact us
          </FooterLinkComponent>
        </FooterContainer>
      </FooterOuterContainer>
    </StyledFooter>
  );
}

export default Footer;
